import { Link } from 'gatsby'
import React from 'react'

const SuburbBanner = () => {
  return (
    <Link to="/" style={{ textDecoration: 'none' }}>
      <div className="header-banner">
        🍔 Looking for our lunch product? &nbsp;
        <Link to="/">View here.</Link>
      </div>
    </Link>
  )
}

export default SuburbBanner
